<template>
  <page-header title="Проекты" icon="bi-gear"/>
  <std-table
      :format="[
        ['project_id','ID проекта'],
        ['description','Описание'],
        ['nlu','NLU', (i)=>i.nlu || 'Нет'],
        ['tgbot','Телеграм бот', (i)=>i.tgbot || 'Нет'],
        ['maxbot','Макс бот', (i)=>i.maxbot || 'Нет'],
        ['http_ep_config','HTTP', (i)=>i.http_ep_config || 'Нет'],
      ]"
      url="/projects"
      resource="project"
      button="Создать новый проект"
  />


</template>

<script>
import PageHeader from "@/components/PageHeader";
import StdTable from "@/components/StdTable";

export default {
  components: {StdTable, PageHeader},
}
</script>

